import React from 'react';
import styled from 'styled-components';

import { useTypedSelector } from '@/store/store';
import { selectSinglePost } from '@/store/reducers/single-post';
import HeroWithoutContent from '@/components/HeroWithoutContent';

import Main from './components/Main';
import Socials from './components/Socials';
import MorePosts from './components/MorePosts';

function SinglePostOld() {
  const page = useTypedSelector(selectSinglePost);

  if (!page) {
    return null;
  }

  return (
    <Component>
      {page.image && (
        <HeroWithoutContent
          desktopImage={page.image}
          tabletImage={page.image}
          mobileImage={page.mobileImage}
          alt={(page?.title ?? '') + ' #1'}
          singlePost
        />
      )}
      <Main />
      <Socials />
      <MorePosts />
    </Component>
  );
}

export default SinglePostOld;

const Component = styled.section`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.white};
`;
